<template>
  <div>
    <v-card class="pa-2 editor-menu" elevation="0">
      <div style="width: 220px">
        <v-select
          label="Pages"
          :items="projectPages"
          dense
          outlined
          :value="selectedPage.id"
          @change="onPageChange"
          item-value="id"
          item-text="name"
          return-object
        >
          <template slot="item" slot-scope="data">
            <div
              style="
                display: flex;
                flex-direction: column;
                margin-bottom: 5px;
                margin-top: 5px;
              "
            >
              <div>{{ data.item.name }}</div>
              <small>{{ data.item.url }}</small>
            </div>
          </template>
        </v-select>
      </div>
      <div style="display: flex; flex-wrap: wrap">
        <v-chip
          class="ma-1 ml-2"
          color="primary"
          outlined
          @click="showPageConfigDialog()"
        >
          <v-icon small left>mdi-cog</v-icon>Page Settings
        </v-chip>
        <v-chip
          class="ma-1"
          color="primary"
          outlined
          @click="showNewPageDialog = true"
        >
          <v-icon small left>mdi-plus</v-icon>New Page
        </v-chip>
        <v-chip
          class="ma-1"
          color="error"
          outlined
          @click="tryDeletePage()"
          :disabled="pageDeleting"
          v-if="selectedPage.canDelete"
          >{{ pageDeleting ? "Deleting..." : "Delete Page" }}</v-chip
        >
      </div>
      <div
        style="
          flex-grow: 1;
          display: flex;
          align-items: center;
          justify-content: flex-end;
        "
      >
        <EditorSetingsButton></EditorSetingsButton>
      </div>
    </v-card>
    <v-dialog v-model="showEditingPageDialog" width="800" :scrollable="true">
      <PageConfigCard
        @close="showEditingPageDialog = false"
        :page="selectedPage"
      ></PageConfigCard>
    </v-dialog>
    <v-dialog v-model="showNewPageDialog" width="800">
      <NewPageDialog @close="showNewPageDialog = false"></NewPageDialog>
    </v-dialog>
  </div>
</template>

<script>
import NewPageDialog from "./NewPageDialog";
import EditorSetingsButton from "./EditorSetingsButton";
import PageConfigCard from "./PageConfigCard";
import projectMixin from "./project-mixin";

export default {
  components: {
    NewPageDialog,
    PageConfigCard,
    EditorSetingsButton,
  },
  mixins: [projectMixin],
  data() {
    return {
      showEditingPageDialog: false,
      showNewPageDialog: false,
    };
  },
  methods: {
    showPageConfigDialog() {
      this.showEditingPageDialog = this.selectedPage;
    },
    async tryDeletePage() {
      if (confirm("Delete this page?")) {
        await this.deletePage(this.selectedPage);
        this.$emit("close");
        this.broadcastPageDeleted();
      }
    },
  },
};
</script>

<style scoped>
.editor-menu {
  display: flex;
  align-items: center;
  position: fixed;
  top: 40px;
  left: 0;
  right: 0;
  height: 80px;
}
</style>